const messages = {
  name: 'Statistics',
  fields: {
    accountName: 'Account Name',
    api: 'Api',
    lastAccess: 'Last access',
    lastDaySuccessfulAccess: 'Last Day Successful Access',
    lastDayWrongAccess: 'Last Day Wrong Access',
    lastWeekSuccessfulAccess: 'Last Week Successful Access',
    lastWeekWrongAccess: 'Last Week Wrong Access',
    lastMonthSuccessfulAccess: 'Last Month Successful Access',
    lastMonthWrongAccess: 'Last Month Wrong Access',
  },
  filters: {
    accountName: 'Account Name',
  },
  dashboard: {
    period: 'Period',
    account: 'Account',
    allAccounts: 'All accounts',
    kpiProcessing: 'Processing time',
    kpiProcessingP95: 'p95 %{p95}',
    colProcessing: 'Processing',
    colDelivery: 'Delivery',
    periodToday: 'Today',
    period7d: '7 days',
    period30d: '30 days',
    periodCustom: 'Custom',
    from: 'From',
    to: 'To',
    channel: 'Channel',
    allChannels: 'All channels',
    kpiSent: 'Deliveries',
    kpiSuccessRate: 'Success rate',
    kpiFailed: 'Failed',
    kpiActiveAccounts: 'Active accounts',
    deltaFlat: '▬ no change',
    deltaVsPrev: 'vs. previous period',
    chartTitle: 'Deliveries per day and channel',
    chartSubtitle: "Stacked by channel; the red cap is that day's failures",
    legendFailed: 'Failed',
    byChannelTitle: 'By channel',
    byChannelSubtitle: 'Volume and success rate for the period',
    topAccountsTitle: 'Top accounts',
    topAccountsSubtitle: 'Deliveries per account in the period',
    colChannel: 'Channel',
    colSent: 'Sent',
    colSuccess: 'Success',
    colAccount: 'Account',
    colRequests: 'Deliveries',
    colErrors: 'Errors',
    colStatus: 'Status',
    colEndpoint: 'Endpoint',
    colErrors24h: 'Errors 24h',
    colErrorsPeriod: 'Errors in period',
    colOkPeriod: 'OK in period',
    failPct: '%{pct}% errors',
    apiHealthTitle: 'API health',
    apiHealthSubtitle: 'Only accounts/endpoints with errors in the period',
    apiHealthEmpty: 'No API errors in this period',
    viewApiTable: 'View all API statistics →',
    hideApiTable: 'Hide API statistics',
  },
};

export default messages;
